import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/regenerator/index.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import "core-js/modules/esnext.global-this.js";
import { settings, ExtensionType, BaseTexture, utils, extensions } from '@pixi/core';
import { checkDataUrl } from '../../../utils/checkDataUrl.mjs';
import { checkExtension } from '../../../utils/checkExtension.mjs';
import { LoaderParserPriority } from '../LoaderParser.mjs';
import { WorkerManager } from '../WorkerManager.mjs';
import { createTexture } from './utils/createTexture.mjs';
var validImageExtensions = [".jpeg", ".jpg", ".png", ".webp", ".avif"];
var validImageMIMEs = ["image/jpeg", "image/png", "image/webp", "image/avif"];
function loadImageBitmap(_x) {
  return _loadImageBitmap.apply(this, arguments);
}
function _loadImageBitmap() {
  _loadImageBitmap = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(url) {
    var response, imageBlob, imageBitmap;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return settings.ADAPTER.fetch(url);
        case 2:
          response = _context2.sent;
          if (response.ok) {
            _context2.next = 5;
            break;
          }
          throw new Error("[loadImageBitmap] Failed to fetch ".concat(url, ": ").concat(response.status, " ").concat(response.statusText));
        case 5:
          _context2.next = 7;
          return response.blob();
        case 7:
          imageBlob = _context2.sent;
          _context2.next = 10;
          return createImageBitmap(imageBlob);
        case 10:
          imageBitmap = _context2.sent;
          return _context2.abrupt("return", imageBitmap);
        case 12:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _loadImageBitmap.apply(this, arguments);
}
var loadTextures = {
  extension: {
    type: ExtensionType.LoadParser,
    priority: LoaderParserPriority.High
  },
  config: {
    preferWorkers: true
  },
  test: function test(url) {
    return checkDataUrl(url, validImageMIMEs) || checkExtension(url, validImageExtensions);
  },
  load: function load(url, asset, loader) {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var src, base;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            src = null;
            if (!globalThis.createImageBitmap) {
              _context.next = 18;
              break;
            }
            _context.t0 = _this.config.preferWorkers;
            if (!_context.t0) {
              _context.next = 7;
              break;
            }
            _context.next = 6;
            return WorkerManager.isImageBitmapSupported();
          case 6:
            _context.t0 = _context.sent;
          case 7:
            if (!_context.t0) {
              _context.next = 13;
              break;
            }
            _context.next = 10;
            return WorkerManager.loadImageBitmap(url);
          case 10:
            src = _context.sent;
            _context.next = 16;
            break;
          case 13:
            _context.next = 15;
            return loadImageBitmap(url);
          case 15:
            src = _context.sent;
          case 16:
            _context.next = 21;
            break;
          case 18:
            _context.next = 20;
            return new Promise(function (resolve) {
              src = new Image();
              src.crossOrigin = "anonymous";
              src.src = url;
              if (src.complete) {
                resolve(src);
              } else {
                src.onload = function () {
                  resolve(src);
                };
              }
            });
          case 20:
            src = _context.sent;
          case 21:
            base = new BaseTexture(src, _objectSpread({
              resolution: utils.getResolutionOfUrl(url)
            }, asset.data));
            base.resource.src = url;
            return _context.abrupt("return", createTexture(base, loader, url));
          case 24:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  unload: function unload(texture) {
    texture.destroy(true);
  }
};
extensions.add(loadTextures);
export { loadImageBitmap, loadTextures };